import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=2d63fe7c&scoped=true&"
import script from "./Work.vue?vue&type=script&lang=ts&"
export * from "./Work.vue?vue&type=script&lang=ts&"
import style0 from "./Work.vue?vue&type=style&index=0&id=2d63fe7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63fe7c",
  null
  
)

export default component.exports